import { createSelector } from 'reselect'
import { getThe, select } from '../utils'
import { selectUnverifiedCELs } from './loans'

const getHomeownerData = state => state.homeowner
const selectFromHomeownerData = select(getHomeownerData)

export const selectLoanFocus = selectFromHomeownerData(getThe('loanFocus'))

const getHasCheckedLoanNumbers = state => state.homeowner.hasCheckedLoanNumbers

export const selectShouldCheckLoanNumbers = createSelector(
  selectUnverifiedCELs,
  getHasCheckedLoanNumbers,
  (unvLoans = [], hasChecked) => Boolean(unvLoans.length && !hasChecked)
)

export const selectIsDashFocused = createSelector(selectLoanFocus, focus => !focus)
